import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import ButtonComponent from "../Button/ButtonComponent";

interface ModalConfirmComponentProps {
    open: boolean;
    onClose: () => void;
    title: string;

    labelCancelar: string;
    onClickCancelar: () => void;

    labelConfirmar: string;
    onClickConfirmar: () => void;
}

const buttonStyle = {
    width: '119px',
    height: '42px',
    padding: '8px 24px',
    borderRadius: '8px',
    opacity: 1,
    minWidth: 'auto',

    border: '1px solid var(--color-orange-87, #E8DFD5)',

    fontFamily: '"Font 7", sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    textAlign: 'center',
    textTransform: 'none',

    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    boxSizing: 'border-box',

    // // Efeito de hover básico para o botão não parecer estático
    // '&:hover': {
    //     backgroundColor: 'rgba(232, 223, 213, 0.08)', // Um leve reflexo no tom da borda
    //     border: '1px solid var(--color-orange-87, #E8DFD5)',
    // }
}

const ModalConfirmComponent = (props: ModalConfirmComponentProps) => {
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        props.onClickConfirmar();
    };

    return <Dialog
        //fullScreen
        open={props.open}
        onClose={props.onClose}
        //TransitionComponent={Transition}
        PaperProps={{
            component: "form",
            onSubmit: handleSubmit
        }}
        sx={{
            "& .MuiDialog-paper": {
                width: 448,
                maxWidth: 448,
            }
        }}
    >
        <DialogTitle
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontFamily: '"Font 7", sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '32px',
                letterSpacing: '0%',
                color: '#2C2C2C',
                // display: 'inline-flex',
                // alignItems: 'center',
                // verticalAlign: 'middle',
            }}
        >
            {props.title}

            <IconButton onClick={props.onClose}>
                X
            </IconButton>
        </DialogTitle>
        {/* <DialogContent sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2
        }}>
            
        </DialogContent> */}
        <DialogActions>
            <ButtonComponent
                id="cancelar"
                variant="outlined"
                type="button"
                sx={{ ...buttonStyle, color: '#2C2C2C' }}
                onClick={props.onClose}
            >
                {props.labelCancelar}
            </ButtonComponent>
            <ButtonComponent
                id="salvar"
                variant="outlined"
                type="submit"
                sx={{ ...buttonStyle, backgroundColor: "#FF8C42", color: '#FFFFFF' }}
            >
                {props.labelConfirmar}
            </ButtonComponent>
        </DialogActions>
    </Dialog>
}

export default ModalConfirmComponent;